<template>
  <div class="content">
    <p>
      <strong>传统液态氧：</strong>
    </p>
    <p>
      <strong>一、运作方式和不足之处:</strong>
    </p>
    <p>
      1、传统的液态氧和钢瓶氧供氧方式还停留在客户提出需求后，商业提供运输和送货的传统供应模式中，这一运作方式给医院管理带来了诸多不便，例如必须提前储备足量的液态氧，否则容易导致紧急时中断氧气供应的医疗事故，医院必须提前预计用量、评估库存、下单采购等诸多环节非常不方便。
    </p>
    <p>
      2、医院无法有效复核所采购的液态氧和钢瓶氧的装量是否足够，只能听任厂家的报量，很难判断资金使用的有效性，不能做到透明消费。
    </p>
    <p>
      3、医院无法有效监测所采购液态氧和钢瓶氧的纯度是否达到国家标准，近年已经发生多起工业液态氧冒充医用氧导致医院医疗事故的问题发生，医院容易遭到不良厂家的责任牵连，给医院管理造成麻烦。
    </p>
    <p>
      <strong>二、安全隐患：</strong>
    </p>
    <p>1、液态氧容易导致医疗事故：液态氧生产的工艺流程导致其杂质为：甲烷、</p>
    <p>
      一氧化碳、甲醛等对人体高度有害的物质，所以国家对医用液态氧的纯度要求非常高，一旦工业用液态氧流入医院容易导致老年和婴幼儿患者最先出现呼吸困难和中毒事故发生。
    </p>
    <p>
      2、液态氧、钢瓶氧都有爆炸危险：液态氧极易挥发，膨胀比是860
      :1，容器的压力极高，对储运设施的质量要求和安全要求极高，一旦罐体破裂，液态氧会立刻导致爆炸及爆燃事故。
    </p>
    <p>
      3、液态氧有严重冻伤危险：液态氧的沸点为零下183℃，直接接触人体会造成严重冻伤事故。
    </p>
    <p>
      4、液态氧、钢瓶氧有火灾危险：属于高度助燃物质，直接接触油脂或者沥青路面就会直接导致爆燃。
    </p>
    <p>
      <strong>三、进行改造的必要性：</strong>
    </p>
    <p>
      液态氧目前已经成为医院安全运营中最大的一个安全隐患，仅仅2016年5月一个月内就发生的具有全国影响的钢瓶及液氧事故列举如下：
    </p>
    <p>
      1、5月12日，江苏镇江市中医院（3甲）钢瓶氧储罐因年久失修发生破裂事故，超低温液氧喷出导致多人受伤的事故。
    </p>
    <p>
      2、5月26日，河南洛阳偃师闹市区发生钢瓶氧罐车倾覆事故，导致21人伤亡，幸亏消防部门及时堵住了钢瓶氧泄漏，否则不堪设想。
    </p>
    <p>
      3、5月16日，福建医科大学附属二院（3甲）住院部爱国楼发生钢瓶氧泄压事故，造成患者和医护人员恐慌，人员紧急疏散，幸好没有人员伤亡。
    </p>
    <p>
      4、5月28日，北京通州人民医院发生钢瓶氧爆炸事故，导致1名氧气班工人死亡。
    </p>
    <p>
      5、工业氧以次充好冒充医用氧，医院难以自行监测钢瓶氧纯度和复核装量，一旦导致事故容易使医院受到不道德厂家的牵连：2016年5月10日，经过多年跟踪调查，广东主流媒体彻底曝光了粤东揭阳地区钢瓶氧厂家忠泰公司掺杂使假，以工业液态氧兑入医用液态氧供应粤东地区多家大医院，年供货超过2500吨的特大氧气事故，并导致多名分管领导受到组织调查。
    </p>
    <p>
      <img src="../../assets/images/airsep/project2.png" alt="">
      <img src="../../assets/images/airsep/project3.png" alt="">
      <img src="../../assets/images/airsep/project4.png" alt="">
    </p>
    <p>
      <strong>医用中心制氧系统</strong>
    </p>
    <p>
      <strong
        >医用分子筛自制氧供氧方式淘汰液态氧供氧方式是医院管理升级、技术进步的必然趋势</strong
      >
    </p>
    <p>
      1、液态氧传统供氧方式，因液态氧超高压、超低温、不稳定、极易发生爆炸事故的物理特性，以及无法数字化监控管理等固有问题，以及液态氧运输、贮存、使用中极易发生泄漏、泄压、爆炸等事故，在国家消防法中有明文规定属于高危险品，这些都决定了液态氧已经与当代医院实现现代化管理追求高控制性、高安全性、高技术性的大时代背景完全背离，所以欧美发达国家医院已经于本世纪初完全停止了液态氧在医院领域的使用。
    </p>
    <p>
      2、医用分子筛制氧系统，是在常温常压下运行，以自然空气为原料实时生产氧气，没有理论安全风险，可以完全杜绝液态氧潜在的安全隐患。而液态氧传统供氧方式是在超高压、超低温、高设备腐蚀、高管道腐蚀和压力不稳状态下运行，安全风险巨大。
    </p>
    <p>3、医用分子筛制氧</p>
    <p>工作压力&lt;5kg/cm²，低于国家消防要求规定！无需办理消防许可。</p>
    <p>
      而液态氧供氧方式必须严格遵守消防规定，目前只有很少数医院能够完全达标，给广大医院带来的消防和管理成本都很高。
    </p>
    <p>
      4、医用分子筛制氧系统已经完全实现数字化、全自动化运行，为医院节约大量人力资源，供氧压力长期稳定、氧气浓度长期稳定超过国家标准，机组实现了无人值守，并实现了机组远程网络监控。
    </p>
  </div>
</template>

<script>
export default {
  name: 'TabLiquidOxygenHazards'
}
</script>

<style lang="scss" scoped>
.content {
  font-size: 18px;
  color: #6a6a6a;
  p {
    line-height: 36px;
    text-indent: 40px;
  }
  strong{
    font-size: 20px;
    font-weight: 700;
  }
}
</style>
